import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCallback } from 'react';
import { usePortalsAuth, HubSpotForm, getPortalEnv, getPortalHublet } from 'portals-platform-lib';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export function TicketCreation({
  onSuccess,
  formGuid,
  portalData
}) {
  var _getPortalEnv;
  const {
    user
  } = usePortalsAuth();
  const email = user === null || user === void 0 ? void 0 : user.email;
  const contactVid = user === null || user === void 0 ? void 0 : user.contactVid;
  const onFormReady = useCallback(instance => {
    if (!contactVid) {
      return;
    }
    const submissionMetadata = {
      existingContactVid: String(contactVid)
    };
    if (instance.version === 2 && 'setExtraSubmissionMetadata' in instance) {
      instance.setExtraSubmissionMetadata(submissionMetadata);
    } else if (instance.version === 1) {
      instance.setContext({
        extraSubmissionMetadata: submissionMetadata
      });
    }
  }, [contactVid]);
  const onFormSubmitted = useCallback(() => {
    FloatingAlertStore.addAlert({
      message: I18n.text('customer-portal-app.ticketSubmittedAlert.message'),
      titleText: I18n.text('customer-portal-app.ticketSubmittedAlert.title'),
      type: 'success'
    });
    onSuccess();
  }, [onSuccess]);
  return /*#__PURE__*/_jsx(HubSpotForm, {
    formId: formGuid,
    portalId: String(portalData.portalId),
    env: (_getPortalEnv = getPortalEnv()) !== null && _getPortalEnv !== void 0 ? _getPortalEnv : '',
    region: getPortalHublet(),
    prefill: email ? {
      CONTACT: {
        email
      }
    } : undefined,
    onFormReady: onFormReady,
    onFormSubmitted: onFormSubmitted,
    loadingFallback: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "400",
      "aria-label": I18n.text('customer-portal-app.loading')
    })
  });
}